import Vue from "vue";
import 'echarts/map/js/china.js';
// import 'echarts/map/js/world.js';
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
